export const getInitialTransportSearchState = () => ({
  data: [],
  isLoading: false,
  isSuccess: false,
  error: null
});

export const getUniqueOfferTypes = (airportOffers: any[] | null | undefined) =>
  Array.from(new Set((airportOffers || []).map(offer => offer?.type).filter(Boolean)));

export const mapAvailableAirportsToOptions = (data: any[]) =>
  (data || []).map((a: any) => ({
    ...a,
    value: a.iata_code,
    label: a.name
  }));
